import Api from '@api/yun_xuan/experienceShopApi'
import { getMomentTime } from '@hlj/hlj-utils'
import BaseStore from '@store/table'
import { Modal } from 'hljd'
import { action, observable } from 'mobx'

class Store extends BaseStore {
  $listApi = Api.getListApi
  $ignoreParams = ['date']
  $getParams = () => {
    const { date, ...rest } = this.$params
    return {
      ...rest,
      created_from: date && getMomentTime(date, 0),
      created_to: date && getMomentTime(date, 1),
      tab: this.activeTab
    }
  }
  @observable activeTab = 'all'

  @action
  initialTab = key => {
    this.activeTab = key
  }

  @action
  changeTab = key => {
    this.activeTab = key
    this.$getList(1)
  }

  @observable _ts = ''
  @observable _time = {}
  @action
  formatSeconds = ($ts, $id) => {
    let _t = null
    let _ts = this._time[$ts] - 1
    let theTime = parseInt(_ts)
    let theTime1 = 0
    let theTime2 = 0
    if (theTime > 60) {
      theTime1 = parseInt(theTime / 60)
      theTime = parseInt(theTime % 60)

      if (theTime1 > 60) {
        theTime2 = parseInt(theTime1 / 60)
        theTime1 = parseInt(theTime1 % 60)
      }
    }
    let result = '' + parseInt(theTime)
    if (theTime1 > 0) {
      result = '' + parseInt(theTime1) + ':' + result
    }
    if (theTime2 > 0) {
      result = '' + parseInt(theTime2) + ':' + result
    }
    _t = setTimeout(() => {
      this._time[$ts] = _ts
      this.formatSeconds($ts, $id)
    }, 1000)
    if (this._time[$ts] == 0 || this._time[$ts] < 0) {
      clearTimeout(_t)
      document.getElementById($id + 'btn').innerHTML = '已过期'
      this.$list = this.$list.map(item => {
        if (item.id === $ts) {
          item.disabled = true
        }
        return item
      })
    }
    if (document.getElementById($id)) {
      // TODO
      document.getElementById($id).innerHTML = `剩余${result}`
    }
  }

  @observable
  un_read = {
    unread_count: 0,
    read_count: 0,
    come_count: 0,
    formed_count: 0
  }
  @action
  $extraOp = data => {
    const { unread_count, read_count, come_count, formed_count, list = [] } =
      data || {}
    Object.assign(this.un_read, {
      unread_count,
      read_count,
      come_count,
      formed_count
    })
    list.forEach(v => {
      if (v.time_remain !== 0) {
        this._time[v.id] = v.time_remain
      }
    })
    this.$list = list.map(item => {
      item.disabled = item.status + '' === '2'
      return item
    })
  }
  @action
  comeMerchant = (is_come, id, status) => () => {
    if (is_come + '' === '0' && ['0', '2'].indexOf(status + '') <= -1) {
      Modal.confirm({
        title: '你是否确认“已到店”？',
        onOk: async () => {
          let { success } = await Api.comeMerchantApi({ id })
          if (success) this.$getList()
        }
      })
    }
  }

  @action
  toDetail = id => () => {
    window.open(`#/localMerchant/experienceShop/detail/${id}`)
    setTimeout(() => {
      this.$getList()
    }, 3000)
  }
}
export default Store
